import { render } from "./Layout.vue?vue&type=template&id=480e474c&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=480e474c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480e474c"]])

export default __exports__